import React, { useState } from 'react';
import { OverlayDialog } from 'app/components/Dialogs';
import { ChakraFabButton } from 'app/components/Core';
import { ReactComponent as AddIcon } from 'resources/images/add.svg';
import { Release } from 'types/releases';
import { ReleaseAudioSelectOverlay } from 'app/components/Releases/ReleaseAudioSelectOverlay';
import { audioSelectScreenClosedAction } from 'app/store/Mixpanel/slice';
import { useAppDispatch } from 'app/store';

interface AddReleaseVersionDialogProps {
  release: Release;
}

export const AddReleaseVersionDialog = ({
  release,
}: AddReleaseVersionDialogProps) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    dispatch(audioSelectScreenClosedAction({ releaseType: release.type }));
  };

  return (
    <>
      <ChakraFabButton
        aria-label="add"
        data-testid="add-version"
        leftIcon={<AddIcon />}
        onClick={() => {
          setOpen(true);
        }}
      >
        Add Audio
      </ChakraFabButton>

      {open && (
        <OverlayDialog onClose={handleClose}>
          <ReleaseAudioSelectOverlay
            onClose={() => setOpen(false)}
            release={release}
          />
        </OverlayDialog>
      )}
    </>
  );
};
